import {
  LimitPaginationParams,
  PagePaginationParams,
  PageResponse,
  Entry,
  APIPath,
} from '@/cms';

import { apiCallStrapi } from '@/utils/fetch';

export async function getEntries<T extends Entry = Entry>({
  apiPath,
  query = {},
  signal,
  next,
}: {
  apiPath: APIPath;
  query?: {
    pLevel?: string;
    populate?: string | Record<string, any>;
    pagination?: LimitPaginationParams | PagePaginationParams;
    filters?: Record<string, any>;
    sort?: string | string[];
  };
  signal?: AbortSignal | null;

  next?: NextFetchRequestConfig;
}) {
  if (!query.pagination) {
    query.pagination = {
      page: 1,
      pageSize: 10,
    };
  }

  const response = await apiCallStrapi<PageResponse<T>>({
    path: apiPath,
    query,
    signal,
    next,
    fetchOptions: {
      cache: 'force-cache',
    },
  });

  return response;
}
